import React from 'react'
import ModalPortal from '@Components/Popups/ModalPortal'
import Sidebar from '@Components/Sidebars/Sidebar'
import AddOriginalPublisher from '@Components/WorkRegistrationSubs/AddOriginalPublisher'
import AddAdministratorPublisher from '@Components/WorkRegistrationSubs/AddAdministratorPublisher'
import { PublisherSideBarState } from '@App/enum/publisher-side-bar-state'

interface PublisherSidebarModalProps {
    sidebarState: PublisherSideBarState
    onClose: () => void
}

const PublisherSidebarModal = ({ sidebarState, onClose }: PublisherSidebarModalProps) => (
    <ModalPortal isOpen={sidebarState !== PublisherSideBarState.empty} onClose={onClose}>
        <Sidebar onClose={onClose}>
            {sidebarState === PublisherSideBarState.addOP && <AddOriginalPublisher isRHRestricted={false} />}
            {sidebarState === PublisherSideBarState.addAP && <AddAdministratorPublisher isRHRestricted={false} />}
        </Sidebar>
    </ModalPortal>
)

export default PublisherSidebarModal
